// Import a single Froala Editor plugin.
import 'froala-editor/js/froala_editor.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgArrayPipesModule, NgStringPipesModule } from 'angular-pipes';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { NgxPopperModule } from 'ngx-popper';

import * as Pipe from '@reg/shared/pipe';
import * as Validator from '@reg/shared/validator';
import * as ControlDirective from '@reg/shared/control-directive';
import * as MsgBox from '@reg/shared/message-box';
import * as Toast from '@reg/shared/toast';
import * as Spinner from '@reg/shared/spinner';
import * as Location from '@reg/shared/location';
import * as PersonDob from '@reg/shared/person-dob';
import * as HtmlEditor from '@reg/shared/html-editor';
import * as Modal from '@reg/shared/modal';
import { CommonModule } from '@angular/common';
import { MultiSelectionComponent } from '@reg/shared/multi-selection/multi-selection.component';
import { EventMultiSelectionComponent } from '@reg/shared/multi-selection/event-multi-selection.component';

/**
 * Shared Components are exported from this SharedModule
 * so we can re-use them in many places around our App
 */
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        NgArrayPipesModule,
        NgStringPipesModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        NgxPopperModule.forRoot({}),
    ],

    declarations: [
        Toast.ToastComponent,
        Spinner.SpinnerComponent,
        ControlDirective.GooglePlacesSearchDirective,
        ControlDirective.DateTimePickerDirective,
        ControlDirective.ScrollDetectionDirective,
        Pipe.DateTimeZonePipe,
        Pipe.TimeZoneAbbrPipe,
        Pipe.MoneyPipe,
        Pipe.MoneyObjectPipe,
        Pipe.SafeHtmlPipe,
        Pipe.OrdinalPipe,
        Validator.AccountNumberDirective,
        Validator.EmailDirective,
        Validator.UrlDirective,
        Validator.RangeDirective,
        Validator.RequiredIfDirective,
        Validator.RoutingNumberDirective,
        Validator.UsaWrestlingNumberDirective,
        Validator.ValidIfDirective,
        Validator.UserCoreEmailDirective,
        Validator.UserCoreEmailCheckDirective,
        Validator.UserCoreUsernameCheckDirective,
        Validator.ExternalLinkCheckDirective,
        Validator.CouponCodeCheckDirective,
        Validator.InvalidWarningComponent,
        Validator.NumberDirective,
        MsgBox.MessageBoxComponent,
        Location.LocationComponent,
        PersonDob.PersonDobComponent,
        HtmlEditor.HtmlEditorComponent,
        Modal.ModalComponent,
        EventMultiSelectionComponent,
        MultiSelectionComponent,
    ],

    exports: [
        CommonModule,
        NgArrayPipesModule,
        NgStringPipesModule,
        FroalaEditorModule,
        FroalaViewModule,
        Toast.ToastComponent,
        Spinner.SpinnerComponent,
        ControlDirective.GooglePlacesSearchDirective,
        ControlDirective.DateTimePickerDirective,
        ControlDirective.ScrollDetectionDirective,
        Pipe.DateTimeZonePipe,
        Pipe.TimeZoneAbbrPipe,
        Pipe.MoneyPipe,
        Pipe.MoneyObjectPipe,
        Pipe.SafeHtmlPipe,
        Pipe.OrdinalPipe,
        Validator.AccountNumberDirective,
        Validator.EmailDirective,
        Validator.UrlDirective,
        Validator.RangeDirective,
        Validator.RequiredIfDirective,
        Validator.RoutingNumberDirective,
        Validator.UsaWrestlingNumberDirective,
        Validator.ValidIfDirective,
        Validator.UserCoreEmailDirective,
        Validator.UserCoreEmailCheckDirective,
        Validator.UserCoreUsernameCheckDirective,
        Validator.ExternalLinkCheckDirective,
        Validator.InvalidWarningComponent,
        Validator.CouponCodeCheckDirective,
        Validator.NumberDirective,
        MsgBox.MessageBoxComponent,
        Location.LocationComponent,
        PersonDob.PersonDobComponent,
        HtmlEditor.HtmlEditorComponent,
        Modal.ModalComponent,
        EventMultiSelectionComponent,
        MultiSelectionComponent,
    ],
})
export class SharedModule {
}

